<script lang="ts">
    import Editor from '@tinymce/tinymce-svelte'
    import { onMount } from 'svelte'

    export let value = ''
    export let allowImage = true

    let tinymce = null
    let fileInput = null

    let loaded = false

    let confNoImage = {
        menubar: false,
        content_css: '/tinymce.css',
        plugins: ['lists', 'table'],
        a11y_advanced_options: true,
        file_picker_types: undefined,
        toolbar:
            'fontfamily fontsize lineheight | forecolor backcolor | bold italic underline strikethrough | alignnone alignleft aligncenter alignright | numlist bullist | table | removeformat',
        init_instance_callback: (editor) => {
            tinymce = editor
        },
    }

    let confImage = {
        menubar: false,
        content_css: '/tinymce.css',
        plugins: ['lists', 'table', 'image'],
        a11y_advanced_options: true,
        file_picker_types: 'image',
        toolbar:
            'fontfamily fontsize lineheight | forecolor backcolor | bold italic underline strikethrough | alignnone alignleft aligncenter alignright | numlist bullist | image | table | removeformat',
        init_instance_callback: (editor) => {
            tinymce = editor
        },
        file_picker_callback: (cb, value, meta) => {
            fileInput.onchange = () => {
                let file = fileInput.files[0]
                let reader = new FileReader()
                reader.onload = () => {
                    let id = 'blobid' + new Date().getTime()
                    let blobCache = tinymce.editorUpload.blobCache
                    let base64 = reader.result.toString().split(',')[1]
                    let blobInfo = blobCache.create(id, file, base64)
                    blobCache.add(blobInfo)
                    /* call the callback and populate the Title field with the file name */
                    cb(blobInfo.blobUri(), { title: file.name })
                }
                reader.readAsDataURL(file)
            }
            fileInput.click()
        },
    }

    let conf = allowImage ? confImage : confNoImage

    onMount(() => (loaded = true))
</script>

<svelte:head>
    <link href="//cdn.quilljs.com/1.3.6/quill.snow.css" rel="stylesheet" />
</svelte:head>

{#if loaded}
    <div class="tiny-custom">
        <input type="file" accept="image/*" bind:this={fileInput} style="position:absolute;top:-100000px;left:-1000px;" />
        <Editor {conf} bind:value scriptSrc="/tinymce/tinymce.min.js" />
    </div>
{/if}

<style>
    :global(.ql-toolbar) {
        background-color: white;
    }
    .editor {
        background-color: #ccc;
        color: black;
        height: 220px;
        font-size: 18px;
        overflow: auto !important;
        min-height: 220px;
    }
    .no-selection {
        user-select: none;
    }
    :global(.ql-editor) {
        max-width: unset;
        margin: 0px 0px;
        background-color: white;
        overflow: unset !important;
        height: unset !important;
        min-height: 1460px;
    }
    :global(.ql-editor ol, .ql-editor ul) {
        padding-left: 0px !important;
    }
</style>
